export default __webpack_public_path__ + "mailchimp.2103a9e0.png";